import React from 'react';
import { styled } from '@linaria/react';

import { isError } from '../../utils/validators';

import CheckIcon from './check.inline.svg';

const CheckboxContainer = styled.div`
  position: relative;
  width: 18px;
  height: 18px;
  min-width: 18px;
  margin-right: 8px;
  top: 2px;
`;

const CheckboxInput = styled.input`
  background-color: transparent;
  border: none;
  appearance: none;
  margin: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;

  & + .bb-checkbox {
    box-shadow: var(--bb-checkbox-box-shadow);
    background-color: var(--bb-checkbox-background-color);
    border-color: var(--bb-checkbox-border-color);
    border-width: var(--bb-checkbox-border-width);
  }

  &:checked:focus + .bb-checkbox,
  &:checked:hover + .bb-checkbox,
  &:checked + .bb-checkbox {
    border-color: var(--bb-checkbox-border-color--checked);
    background-color: var(--bb-checkbox-background-color--checked);
    box-shadow: var(--bb-checkbox-box-shadow--checked);

    & path {
      fill: var(--bb-checkbox-icon-color);
    }

    & svg {
      display: block;
    }
  }

  &:hover {
    cursor: pointer;

    & + .bb-checkbox {
      border-color: var(--bb-checkbox-border-color--hover);
      border-width: var(--bb-checkbox-border-width--hover);
      background-color: var(--bb-checkbox-background-color--hover);
      box-shadow: var(--bb-checkbox-box-shadow--hover);
    }
  }

  &:checked:hover + .bb-checkbox {
    box-shadow: var(--bb-field-box-shadow--hover);
  }

  &:focus {
    & + .bb-checkbox {
      border-color: var(--bb-checkbox-border-color--focus);
      box-shadow: var(--bb-field-box-shadow--focus);
      background-color: var(--bb-checkbox-background-color--focus);
    }
  }

  &:checked:focus + .bb-checkbox {
    box-shadow: var(--bb-field-box-shadow--focus);
  }

  &.error {
    & + .bb-checkbox {
      border-color: var(--bb-error-color);
    }
  }

  &:focus.error {
    & + .bb-checkbox {
      border-color: var(--bb-error-color);
      box-shadow: var(--bb-field-box-shadow--focus-error);
    }
  }
`;

const Checkbox = styled.label`
  width: 100%;
  height: 100%;
  background-color: transparent;
  border-style: var(--bb-checkbox-border-style);
  border-radius: var(--bb-checkbox-border-radius);
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;

  & svg {
    display: none;
  }
`;

export default ({ meta, ...rest }) => (
  <CheckboxContainer>
    <CheckboxInput
      {...rest}
      type="checkbox"
      disabled={meta.submitting}
      className={isError(meta) && 'error'}
    />
    <Checkbox>
      <CheckIcon />
    </Checkbox>
  </CheckboxContainer>
);
